export const OPTIONS_INDEX_OFFSET = 2; // first option is placeholder. second option is the hidden option

export const testIds = {
  designableListWrapper: 'designable_list_wrapper',
  designableListOption: 'designable_list_option',
};
